<template>
	<v-dialog v-model="setdialog.dialog" max-width="60vh" persistent fullscreen>
		<v-card class="dialog1">
			<!-- title -->
			<div class="qrtitle">
				<v-spacer />
				<v-icon @click="setdialog.dialog = false" class="title-icon">mdi-close</v-icon>
			</div>
			<div class="dialog-content">
				<!-- dialog-content -->
				<p class="contentName">{{ setdialog.title }}</p>
				<p class="content">{{ setdialog.content }}</p>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data() {
		return {
			// --- 버튼 ---
		}
	},
	created() {},
	methods: {},
	props: {
		setdialog: Object,
	},
	components: {
		// btn,
	},
}
</script>

<style lang="scss">
.dialog1 {
	.qrtitle {
		height: 60px;
		display: flex;
		align-items: center;
		background-color: white;
		padding: 0 25px;

		h2 {
			color: white;
		}

		.title-icon {
			color: #cfd1d2;
		}
	}

	.dialog-content {
		padding: 0px 40px 40px 40px;
		.divider-dark {
			background-color: black;
		}

		.dialog-left {
			max-width: 200px;
			padding: 20px 25px;
			text-align: right;

			.dialog-star {
				color: red;
				margin-left: 8px;
				width: 8px;
			}
		}

		.dialog-right {
			padding: 20px 25px;
		}
	}
	.bottom {
		display: flex;
		margin-top: 20px;
	}
}

.contentName {
	font-size: 3vh;
	color: black;
	font-weight: bold;
	margin-bottom: 5px !important;
	// span {
	// 	font-size: 2vh;
	// }
}
.content {
	white-space: pre-line;
}
</style>
